import { IGroupInfo } from "@home-health-notify/domain";
import React, { useState } from "react";
import CommonDialog from "../common/CommonDialog/CommonDialog";
import { LupaButton, LupaInfo, LupaModalContent } from "./Calendar.style";

interface LupaModalProps {
  groupInfo: IGroupInfo;
}

const LupaModal = ({ groupInfo }: LupaModalProps) => {
  const [isLupaModalOpen, setIsLupaModalOpen] = useState<boolean>(false);

  const openLupaModal = () => {
    setIsLupaModalOpen(true);
  };

  const closeLupaModal = () => {
    setIsLupaModalOpen(false);
  };
  return (
    <>
      <LupaButton
        variant={"contained"}
        data-testid="update-button"
        onClick={openLupaModal}
      >
        Lupa
      </LupaButton>
      <CommonDialog
        isDialogOpen={isLupaModalOpen}
        onDialogClose={closeLupaModal}
        title="Goals"
        titleAlignment="center"
        maxWidth="xs"
      >
        <LupaModalContent>
          <LupaInfo>1st 30 days 0/0 (Not Met)</LupaInfo>
          <LupaInfo>2nd 30 days 0/0 (Not Met)</LupaInfo>
        </LupaModalContent>
      </CommonDialog>
    </>
  );
};

export default LupaModal;
